import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import swal from 'sweetalert';
import api from 'services/api';

import { Creators as CampaignsActions, Types as CampaignsTypes } from 'store/ducks/campaigns';

function* getCampaignRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/campaign/${id}`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignFailure());
  }
}

function* getCampaignsRequest(action) {
  try {
    const { page } = action.payload;
    const url = `store/v2/campaign?page=${page}&per=25`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignsSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignsFailure());
  }
}

function* createCampaignRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'store/v2/campaign';
    yield call(api.post, url, data);

    yield put(push('/points/campaigns'));
    yield call(swal, 'Adicionado', 'Novo método de pagamento adicionado', 'success');
    yield put(CampaignsActions.createCampaignSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível criar o método de pagamento.', 'error');
    yield put(CampaignsActions.createCampaignFailure());
  }
}

function* updateCampaignRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `store/v2/campaign/${id}`;
    yield call(api.put, url, data);

    yield put(push('/points/campaigns'));
    yield call(swal, 'Atualizado', 'Método de pagamento atualizado', 'success');
    yield put(CampaignsActions.updateCampaignSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao atualizar', 'Não foi possível atualizar o método de pagamento.', 'error');
    yield put(CampaignsActions.updateCampaignFailure());
  }
}

function* deleteCampaignRequest(action) {
  try {
    const { id } = action.payload;
    const url = `store/v2/campaign/${id}`;
    yield call(api.delete, url);

    yield put(push('/points/campaigns'));
    yield call(swal, 'Deletado', 'Método de pagamento deletado', 'success');
    yield put(CampaignsActions.deleteCampaignSuccess());
  } catch (error) {
    yield call(swal, 'Falha ao deletar', 'Não foi possível deletar o método de pagamento.', 'error');
    yield put(CampaignsActions.deleteCampaignFailure());
  }
}

function* getCampaignChannelsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/channels?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignChannelsSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignChannelsFailure());
  }
}

function* getCampaignStoresRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/places?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignStoresSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignStoresFailure());
  }
}

function* getCampaignProductTypesRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/product_types?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignProductTypesSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignProductTypesFailure());
  }
}

function* getCampaignSectionsRequest(action) {
  try {
    const { query } = action.payload;
    const url = `store/v2/sections?search=${query}&per=30`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignSectionsSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignSectionsFailure());
  }
}

function* getCampaignSubSectionsRequest(action) {
  try {
    const { query, section } = action.payload;
    const url = `store/v2/sub_sections?search=${query}${section !== null ? `&section_id=${section}` : ''}&per=30`;
    const response = yield call(api.get, url);

    yield put(CampaignsActions.getCampaignSubSectionsSuccess(response.data));
  } catch (error) {
    yield put(CampaignsActions.getCampaignSubSectionsFailure());
  }
}

export default function* sagaCampaigns() {
  yield takeLatest(CampaignsTypes.GET_REQUEST, getCampaignRequest);
  yield takeLatest(CampaignsTypes.GET_LIST_REQUEST, getCampaignsRequest);
  yield takeLatest(CampaignsTypes.CREATE_REQUEST, createCampaignRequest);
  yield takeLatest(CampaignsTypes.UPDATE_REQUEST, updateCampaignRequest);
  yield takeLatest(CampaignsTypes.DELETE_REQUEST, deleteCampaignRequest);
  yield takeLatest(CampaignsTypes.GET_CHANNELS_REQUEST, getCampaignChannelsRequest);
  yield takeLatest(CampaignsTypes.GET_STORES_REQUEST, getCampaignStoresRequest);
  yield takeLatest(CampaignsTypes.GET_PRODUCT_TYPES_REQUEST, getCampaignProductTypesRequest);
  yield takeLatest(CampaignsTypes.GET_SECTIONS_REQUEST, getCampaignSectionsRequest);
  yield takeLatest(CampaignsTypes.GET_SUB_SECTIONS_REQUEST, getCampaignSubSectionsRequest);
}
